<div class="container">
  <div class="title-row">
    <h3 class="klabel-huge">Filter by Building</h3>
    <app-button
      [text]="'De-select all'"
      class="grey"
      (click)="clearBuildingsFilter()"
    ></app-button>
  </div>
  <div class="content">
    <div class="section">
      <h4 class="section-title">Building Selection</h4>

      <div class="checkbox-group">
        <div class="checkbox-item" *ngIf="buildingsList.length !== 0">
          <input
            type="checkbox"
            class="kinput"
            [checked]="
              buildingsList.length === mainFilter.buildings.length &&
              buildingsList.length !== 0
            "
            (change)="selectAllBuildingsFilter($event)"
            id="selectAllBuildings"
          />
          <label for="selectAllBuildings" class="checkbox-label">
            Select all buildings
            <mat-icon class="checkbox-icon" matTooltip="Select or deselect all buildings at once" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>

        <div class="checkbox-item" *ngFor="let building of buildingsList">
          <input
            type="checkbox"
            class="kinput"
            [checked]="checkIncludesBuilding(building)"
            (change)="updateCheckboxFilter($event, building)"
            [id]="'building-' + building?.buildingName"
          />
          <label [for]="'building-' + building?.buildingName" class="checkbox-label">
            {{ building?.buildingName }}
            <mat-icon class="checkbox-icon" matTooltip="Show courses that take place in this specific building" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
